<!--
  Created 22.06.2023
  Modal for adding new destinations.
  Uses SimpleModalSmall component as a base.
-->
<template>
  <SimpleModalSmall
    :show="showModal"
    heading="Add more destinations"
    text=""
    :button-text="''"
    :overflow-hidden="false"
    @update:show="(value) => showModal = value">
    <p class="text-sm text-gray-500">
      Please search through and select which destination you want to add to your company's database.
    </p>
    <destination-select-picker
      v-model="newPlace"
      :pre-existing-value="preExistingPlaces"
      classes="z-10 mt-4 mb-4 block"
      label="" />
    <template #buttons>
      <button
        tabindex="2"
        type="submit"
        class="inline-flex w-full justify-center rounded-md bg-purple-600 px-3 py-2
          text-sm font-semibold text-white shadow-sm hover:bg-purple-500 sm:ml-3 sm:w-auto"
        @click="addDestination">
        Add destination
      </button>
    </template>
  </SimpleModalSmall>
</template>

<script setup>
import {
  computed, ref,
} from 'vue';
import SimpleModalSmall from '@/Components/Modals/SimpleModalSmall.vue';
import DestinationSelectPickerMultiple from '@/ComponentsDeprecated/Select/DestinationSelectPickerMultiple.vue';
import DestinationSelectPicker from '@/ComponentsDeprecated/Select/DestinationSelectPicker.vue';

const emit = defineEmits(['update:show', 'add:place']);

const props = defineProps({
  show: {
    type: Boolean,
    required: false,
    default: false,
  },
  heading: {
    type: String,
    default: 'Something to be done',
    required: true,
  },
  text: {
    type: String,
    default: 'Please do something here. Thank you.',
    required: true,
  },
  buttonText: {
    type: String,
    default: 'Do something',
    required: true,
  },
  places: {
    type: Array,
    required: false,
    default: [],
  },
});

const loading = ref(false);
const timer = ref(null);

const showModal = computed({
  get() {
    return props.show;
  },
  set(value) {
    emit('update:show', value);
  },
});

const preExistingPlaces = computed(() => props.places);
const newPlace = ref({});

function addDestination() {
  // if destination already exists, close modal and do nothing
  if (preExistingPlaces.value.map((l) => l.id).includes(newPlace.value.id)) {
    loading.value = false;
    showModal.value = false;

    return;
  }

  loading.value = true;
  if (timer.value) {
    clearTimeout(timer);
    timer.value = null;
  }
  timer.value = setTimeout(() => {
    axios
      .get(route('api.destinations.show', { google_maps_id: String(newPlace.value.place_id) }))
      .then((response) => {
        emit('add:place', response.data);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        loading.value = false;
        showModal.value = false;
      });
  }, 500);
}

</script>
